// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__MQAlV"};